import { Timestamp, addDoc, collection } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { PageDataToCreate } from "../types";

type Params = {
  pageData: PageDataToCreate;
  brandId: string;
};

export const createPage = async ({
  pageData,
  brandId,
}: Params): Promise<void> => {
  const collectionRef = collection(db, `brands/${brandId}/pages`);
  await addDoc(collectionRef, {
    ...pageData,
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  });
};
